import React from 'react';
import PropTypes from 'prop-types';
import BodyContent from '../../BodyContent/BodyContent';
import EmbeddedContentStyles from './EmbeddedContent.styled';
import EmbeddedVideo from './EmbeddedVideo';
import EmbeddedQuiz from './EmbeddedQuiz';
import Image from 'next/image';

const EmbeddedContent = ({ embeddedContentObj }) => {
  // destructure
  const {
    embeddedContentHeader,
    embeddedContentSubHeader,
    embeddedContentLongIntro,
    mediaType,
    videoSource,
    embeddedContent,
    bodyCopyHeader,
    bcMedia,
    bodyText,
    disclaimer,
  } = embeddedContentObj;

  return (
    <EmbeddedContentStyles>
      {/* all types of embedded content could have any combination of header, subheader and long intro */}
      {embeddedContentHeader ? (
        <p className="embedded-content-headline">{embeddedContentHeader}</p>
      ) : null}
      {embeddedContentSubHeader ? (
        <p className="embedded-content-sub-headline">
          {embeddedContentSubHeader}
        </p>
      ) : null}
      {embeddedContentLongIntro ? (
        <BodyContent markdown={embeddedContentLongIntro} />
      ) : null}

      {/* If media type Video, create embedded video content */}
      {mediaType === 'Video' ? (
        <EmbeddedVideo
          videoSource={videoSource}
          childMarkdownRemark={embeddedContent}
          disclaimer={disclaimer}
        />
      ) : null}

      {/* If the media type is List or Quiz, create an iframe with the embedded content */}
      {mediaType === 'List' ? (
        <EmbeddedQuiz
          mediaType={mediaType}
          source={embeddedContent}
          disclaimer={disclaimer}
        />
      ) : null}
      {mediaType === 'Quiz' ? (
        <EmbeddedQuiz
          mediaType={mediaType}
          source={embeddedContent}
          disclaimer={disclaimer}
        />
      ) : null}

      {/* Show embedded body copy if they've provided it  */}
      {bodyCopyHeader ? <h4>{bodyCopyHeader}</h4> : null}
      {bcMedia && bcMedia.file && bcMedia.file.url ? (
        <Image src={bcMedia.file.url + '?w=800'} fill />
      ) : null}
      {bodyText ? <BodyContent markdown={bodyText} /> : null}
    </EmbeddedContentStyles>
  );
};

export default EmbeddedContent;

EmbeddedContent.propTypes = {
  embeddedContentObj: PropTypes.object,
};
